const btnCompleteAction = {
  text: 'Concluir acción'
};

export default btnCompleteAction;
